function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.6,49.3v3.3c0,0.4,0.3,0.8,0.8,0.8h22.4c0.4,0,0.8-0.3,0.8-0.8v-3.3c0-4-3.2-7.2-7.2-7.2h-9.5 C17.8,42.1,14.6,45.3,14.6,49.3z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26.6,
  cy: 32.5,
  r: 7.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.8,27.2c0-0.2-0.4-0.4-0.9-0.4H44.5c-0.5,0-0.9,0.2-0.9,0.4V29c0,0.2,0.4,0.4,0.9,0.4h20.4c0.5,0,0.9-0.2,0.9-0.4V27.2z "
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.8,32.3c0-0.2-0.4-0.4-0.9-0.4H44.5c-0.5,0-0.9,0.2-0.9,0.4v1.7c0,0.2,0.4,0.4,0.9,0.4h20.4c0.5,0,0.9-0.2,0.9-0.4V32.3 z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.8,37.4c0-0.2-0.4-0.4-0.9-0.4H44.5c-0.5,0-0.9,0.2-0.9,0.4v1.7c0,0.2,0.4,0.4,0.9,0.4h20.4c0.5,0,0.9-0.2,0.9-0.4V37.4 z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.8,42.5c0-0.2-0.4-0.4-0.9-0.4H44.5c-0.5,0-0.9,0.2-0.9,0.4v1.7c0,0.2,0.4,0.4,0.9,0.4h20.4c0.5,0,0.9-0.2,0.9-0.4V42.5 z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.9,62.8v-47h70.7v27.1H78V16.1c0-1.5-1.2-2.7-2.7-2.7h-70c-1.5,0-2.7,1.2-2.7,2.7v46.3c0,1.5,1.2,2.7,2.7,2.7h40.4 c-0.2-0.6-0.3-1.3-0.3-2.1v-0.2h-0.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.1,59.3H92l-2-6.2c-1-3.2-4-5.3-7.3-5.3H65c-3.4,0-6.3,2.1-7.3,5.3l-2,6.2h-3.1c-1.3,0-2.4,1.1-2.4,2.4v0.4 c0,1.3,1.1,2.4,2.4,2.4h0.9c-0.5,2.2-0.8,5.5-0.8,7.8V84c0,1.3,1.1,2.4,2.4,2.4h1.1c1.3,0,2.4-1.1,2.4-2.4v-3.7H89V84 c0,1.3,1.1,2.4,2.4,2.4h1.1c1.3,0,2.4-1.1,2.4-2.4V72.4c0-2.3-0.3-5.6-0.8-7.8H95c1.3,0,2.4-1.1,2.4-2.4v-0.4 C97.5,60.4,96.4,59.3,95.1,59.3z M60.8,51.7c0.3-1,1.2-1.6,2.2-1.6h21.7c1,0,1.9,0.6,2.2,1.6l3.3,10.2H57.5L60.8,51.7z M63.5,74.2 h-5.8c-0.9,0-1.8-0.8-1.8-1.8v-2.7c0-1.1,0.9-1.9,2-1.8l5.4,0.8c0.7,0.1,1.3,0.7,1.4,1.4l0.4,1.9C65.4,73.1,64.6,74.2,63.5,74.2z  M91.7,72.4c0,0.9-0.8,1.8-1.8,1.8h-5.8c-1.1,0-2-1.1-1.8-2.1l0.4-1.9c0.1-0.7,0.7-1.3,1.4-1.4l5.4-0.8c1.1-0.1,2,0.7,2,1.8"
}));

var SvgDriverLicenseControl = function SvgDriverLicenseControl(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDriverLicenseControl, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/driver-license-control.eca87aa6.svg";
export { ForwardRef as ReactComponent };